var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUganda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9246 27.5171C30.4585 24.6864 32 20.9487 32 16.8505C32 12.7522 30.4584 9.01454 27.9245 6.18379L16 5.02441L4.0755 6.18379C1.54156 9.01454 0 12.7522 0 16.8505C0 20.9487 1.5415 24.6864 4.07544 27.5171L16 28.6765L27.9246 27.5171Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0752 6.1839H27.9243C24.9946 2.91096 20.738 0.850586 15.9997 0.850586C11.2614 0.850586 7.00482 2.91096 4.0752 6.1839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8505L16 18.2418L32 16.8505C32 14.9802 31.6781 13.1853 31.0882 11.5171H0.91175C0.321938 13.1853 0 14.9802 0 16.8505H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.91175 22.1839H31.0884C31.6781 20.5156 32 18.7208 32 16.8506H0C0 18.7208 0.321938 20.5156 0.91175 22.1839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9246 27.5171H4.07544C7.00506 30.7901 11.2616 32.8505 16 32.8505C20.7384 32.8505 24.9949 30.7901 27.9246 27.5171Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3394 16.8508C21.3394 19.7998 18.9492 22.19 16.0003 22.19C13.0513 22.19 10.6611 19.7998 10.6611 16.8508C10.6611 13.9019 13.0513 11.5117 16.0003 11.5117C18.9492 11.5117 21.3394 13.9019 21.3394 16.8508Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9559 17.1228L16 16.2752C16 16.2752 16.4576 14.7563 16.482 14.6523C16.4998 14.5764 16.5093 14.4972 16.5093 14.4158C16.5093 14.1276 16.3925 13.8668 16.2036 13.678L16.6955 13.1861C16.3808 12.8714 15.946 12.6768 15.4657 12.6768C14.9855 12.6768 14.5507 12.8714 14.236 13.1861L14.7279 13.678C14.539 13.8668 14.4222 14.1277 14.4222 14.4158C14.4222 14.5212 14.4382 14.6228 14.4672 14.7187L13.7267 15.4592H15.0727C15.0727 15.4592 14.5162 16.2951 14.2124 16.9815C13.9086 17.6679 14.2166 18.5058 14.9187 18.8179L15.3247 18.9984L16 19.6331V20.3288L15.3044 21.0244H16.6957V19.6331L17.3305 18.9983H18.6435C18.6498 18.9852 18.6564 18.9724 18.6624 18.9591C18.9744 18.257 18.6581 17.4348 17.9559 17.1228Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUganda);
export default __webpack_public_path__ + "static/media/flag_uganda.c631dae999b06839a0d3c4160efbf33d.svg";
export { ForwardRef as ReactComponent };